import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=opening&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '投资减半',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `华美通过系统性优化，在投资规模缩减50%的同时确保酒店品质、客户体验和房价水平不受影响。华美的解决方案包括：采用简约高效的建筑与装修方案，以功能性替代奢华性；优化采购策略，优先选择性价比较高的国产设备和材料。通过科学测算将投资回报率提升至8%以上。`,
        icons: [
            {
                name: '投资减半',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/6.投资减半.pdf'),
                path: "四库赋能-酒店建设/投资减半/投资减半"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店建设/投资减半/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/投资减半/数据赋能'),
                path: "四库赋能-酒店建设/投资减半/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/投资减半/全球案例/全球案例（投资减半）.xlsx'),
                path: "四库赋能-酒店建设/投资减半/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/投资减半/预警问题/预警问题（投资减半）.xlsx'),
                path: "四库赋能-酒店建设/投资减半/预警问题"
            },
        ]
    }]
}